export const defaultFlyAnimationDuration = 500;

export const maxZoomLevel = 24;

// The react mapbox gl updatedViewport for some reason doesn't allow a zoom level lower than ~1.2419
export const minZoomLevel = 1.25;
